import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { StyledStepDotContainer, StyledStepDot, StyledStepLine } from './Steps.styles.js';
function Steps(_ref) {
  let {
    currentStep,
    sx,
    stepsArray,
    width
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: _objectSpread2({
      display: 'flex',
      position: 'relative',
      width: 'fit-content'
    }, sx),
    style: {
      width: width || 'fit-content'
    }
  }, stepsArray.map((step, index) => /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: step
  }, /*#__PURE__*/React__default.createElement(StyledStepDotContainer, {
    active: currentStep > index,
    sx: {
      left: "".concat(index / (stepsArray.length - 1) * 100, "%")
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    mb: "6px",
    sx: {
      whiteSpace: 'nowrap'
    }
  }, step), /*#__PURE__*/React__default.createElement(StyledStepDot, {
    overStep: currentStep > index + 1,
    active: currentStep > index
  })), index < stepsArray.length - 1 && /*#__PURE__*/React__default.createElement(StyledStepLine, {
    active: currentStep > index + 1,
    width: width ? width / (stepsArray.length - 1) : '144px'
  }))));
}
Steps.propTypes = {
  currentStep: PropTypes.number,
  stepsArray: PropTypes.arrayOf(PropTypes.string),
  width: PropTypes.string,
  sx: PropTypes.shape({})
};
Steps.defaultProps = {
  currentStep: 0,
  width: null,
  stepsArray: [],
  sx: {}
};
export { Steps as default };